import GetValidationErrorMessageHandler from '@/services/GetValidationErrorMessageHandler';

export default (ctx, inject) => {
    inject(
        'getValidationErrorMessageHandler',
        new GetValidationErrorMessageHandler()
    );
};
